import React from 'react';
import './Styles.css'; // Assuming you will create a Styles.css for this component

// Terms and Conditions content goes here
const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions </h1>
      <p>Last Updated: 1 Jan 2025</p>
      <p>Welcome to Aura Voyages Private Limited. These Terms & Conditions (“Terms”) govern your use of our website https://auravoyages.com/ (“Website”) and our travel services in India. By booking a tour or using our services, you agree to these Terms.</p>

      <h2>1. Services</h2>
      <p>We provide travel-related services in India, including tour packages, hotel bookings, transportation, guided excursions, and other travel arrangements for foreign travelers as well as Indian travellers.</p>

      <h2>2. Booking & Payment</h2>
      <ul>
        <li>All bookings must be made in writing via email.</li>
        <li>A deposit of 25% of the total package cost is required to confirm your booking. We may need higher deposit depending upon the services included and the period of travel. Same will be communicated to you at the time of making booking.</li>
        <li>Full payment must be received 30 days prior to your arrival in India unless otherwise agreed. In case, travel is happening during peak period like Christmas and New Year or during some specific festival period, hotels or other services providers may ask for full payment much earlier than 30 days prior to your arrival in India.</li>
        <li>Payments are accepted via bank transfer, or other approved and mutually agreed methods.</li>
      </ul>

      <h2>3. Cancellations & Refunds</h2>
      <ul>
        <li>With each proposal shared with the client, we will specify the cancellation and refund policy. These may vary from case to case.</li>
      </ul>

      <h2>4. Travel Documents & Compliance</h2>
      <ul>
        <li>Travelers are responsible for ensuring valid passports, visas, travel insurance, vaccinations, and permits as required for India.</li>
        <li>The Company is not responsible for denied entry, deportation, or other issues arising from incomplete or invalid travel documents.</li>
      </ul>

      <h2>5. Insurance</h2>
      <p>We strongly recommend that all travellers purchase comprehensive travel insurance covering medical expenses, trip cancellations, delays, and personal belongings. For those travelling to High Altitudes and undertaking activities like trekking are recommended to carry High-altitude trekking insurance as it helps the trekkers in case they face any severe situation.</p>

      <h2>6. Responsibilities of the Traveller</h2>
      <ul>
        <li>Follow local laws and cultural norms in India.</li>
        <li>Respect fellow travellers, guides, and service providers.</li>
        <li>Ensure personal belongings are secure. The Company is not liable for theft, loss, or damage.</li>
      </ul>

      <h2>7. Liability Disclaimer</h2>
      <ul>
        <li>We act as an intermediary between travellers and third-party service providers (hotels, transport, guides, airlines, etc.).</li>
        <li>We make every effort to select reliable partners, but we are not liable for injuries, damages, losses, delays, or irregularities caused by third parties, acts of God, or unforeseen circumstances.</li>
        <li>Our liability is limited to the total amount paid for the booked services.</li>
      </ul>

      <h2>8. Itinerary Changes</h2>
      <ul>
        <li>We reserve the right to modify itineraries due to weather, safety, government regulations, or operational needs.</li>
        <li>Efforts will be made to provide equivalent alternatives at no additional cost.</li>
      </ul>

      <h2>9. Complaints & Dispute Resolution</h2>
      <ul>
        <li>If you have a complaint during your trip, notify us immediately so we can attempt to resolve it.</li>
        <li>Any disputes will be governed by the laws of India, with exclusive jurisdiction in the courts of [City, India].</li>
      </ul>

      <h2>10. Intellectual Property</h2>
      <p>All content on our Website, including text, photos, videos, and logos, is owned by the Company and may not be used without permission.</p>

      <h2>11. Amendments</h2>
      <p>We may update these Terms from time to time. Updated Terms will be posted on our Website with a new “Last Updated” date.</p>

      <h2>12. Contact Us</h2>
      <p>If you have questions about these Terms, please contact us at:<br />Aura Voyages Private Limited<br />Email: info@auravoayges.com <br />Phone: +91 98107 20202<br />Address: National Apartment, C-131, Sector 3, Plot No. 4, Dwarka, New Delhi - 110078</p>

    </div>
  );
};

export default TermsAndConditions;